const permitir_informar_data_de_referencia_do_censo = [
  {
    path: "/permitir-marcar-desmarcar-alunos-que-serao-migrados",
    name: "permitir_marcar_desmarcar_alunos_que_serao_migrados",
    meta: {
      breadCrumb: "Censo Escolar - Marcação de Alunos",
      allowedPermissions: ["marcacao_marcar_alunos_migrados"],
    },
    component: () =>
      import(
        "@/views/PermitirMarcarDesmarcarAlunoQueSeraoMigrados/PermitirMarcarDesmarcarAlunoQueSeraoMigrados.vue"
      ),
  },
];

export { permitir_informar_data_de_referencia_do_censo };
